
import Vue from 'vue'

const component = Vue.extend({})

Vue.component('ASnackbar', component)
export default component
